import { React, useState, useEffect } from "react";
import {
  Button,
  Form,
  Input,
  Select,
  Col,
  Row,
  Checkbox,
  Tooltip,
  Radio,
  Dropdown,
  Menu,
  Switch,
} from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import {
  HaberForm,
  RightDrawerContainer,
  DownArrowDraw,
  DetailFields,
} from "../../styledElements";
import RightDrawerSidebar from "../../../Components/RightDrawer/rightDrawer";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import { DisabledButtonStyle } from "../../pageStyled";
import { getOrderTolerances, updateOrderTolerance } from "../../../Services/settingsServices";
import { getMachineGradeSelectForConfig } from "../../../Services/settingsServices";
import { getUnitData } from "../../../Services/measurementService";
import {
  lengthUnit,
  weightUnit,
currency_List 

} from "../../../Utils/Constant/MeasurementUnitList.jsx";

const { Option } = Select;


const OrderToleranceDrawer = (props) => {
    const [toleranceForm] = Form.useForm();
    const [isTouched, setIsTouched] = useState(false);
    const [response, setResponse] = useState();
    const [alert, setAlert] = useState(false);
    const [settings, setSettings] = useState("");
    const [unitData,setUnitData] = useState();

    useEffect(() => {
        fetchSettings();
        getUnitData().then((response) => {
          setUnitData(response.data);
          
        })
        .catch((error) => {
          console.log(error);
        });
    },[]);

    const fetchSettings = async () => {
        const resp = await getOrderTolerances();
        if (!resp.error) {
          setSettings(resp.data.data);
            }
      };

    const onClose = () => {
        setIsTouched(false);
        toleranceForm.resetFields();
        props.onClose();
    };

    const onUpperTolChange = (e) => {
        if(e.target.value !== ""){
            setIsTouched(true);
        }
    };

    const  onLowerTolChange = (e) => {
        if(e.target.value !== ""){
            setIsTouched(true);
        }
    };

    const onFinish = async (e) => {
        let req = {
          order_tolerance:
          {
            upper_tolerance: e.quantity_upper_tolerance,
            lower_tolerance: e.quantity_lower_tolerance,
          },
        gsm_tolerance:
          {
            upper_tolerance: e.gsm_upper_tolerance,
            lower_tolerance: e.gsm_lower_tolerance,
          },
        bf_tolerance:
          {
            upper_tolerance: e.bf_upper_tolerance,
            lower_tolerance: e.bf_lower_tolerance,
          },
        moisture_tolerance:
          {
            upper_tolerance: e.moisture_upper_tolerance,
            lower_tolerance: e.moisture_lower_tolerance,
          },
        size_tolerance:
          {
            upper_tolerance: e.size_upper_tolerance,
            lower_tolerance: e.size_lower_tolerance,
            units : e.size_unit
          }
        };
        try {
          const resp = await updateOrderTolerance(req);
          if (!resp.error) {
            await fetchSettings();
            setResponse(resp);
            setAlert(true);
            setTimeout(() => {
              setAlert(false);
              onClose();
            }, 3000);
          }
        } catch (error) {
          console.log(error);
          setAlert(true);
          if(error?.response?.status == 500){
            setResponse("Something went wrong. Please try again");
            } else{
              setResponse(error.response.data?.msg);
            }
            setTimeout(() => {
            setAlert(false);
          }, 3000);
      };
    };

    return settings && unitData ? (
      <RightDrawerSidebar
        title="Tolerance Specifications"
        subtitle=""
        visible={props.visible}
        onClose={onClose}
      >
        {alert && (
          <AlertContainer
            color={response.error ? "red" : "green"}
            icon={response.error ? alertRed : alertGreen}
            msg={response.msg}
          />
        )}
        <RightDrawerContainer>
        <DetailFields className="marginBtnP">
          <HaberForm>
            <Form
              form={toleranceForm}
              name="basic"
              autoComplete="off"
              style={{ marginTop: "0" }}
              onFinish={onFinish}
            >
              <div className="drawerField removeStar">
                  <div className="titleWithText">
                    <h5>Order Quantity Tolerance</h5>
                    <p>The processed order quantity should be between this tolerance range</p>
                  </div>
                    <Row className="centerAlign " style={{justifyContent : 'space-between'}}>
                      <Col span={12} style={{paddingRight : '5px'}}>
                        <div
                          className="boxFormType"
                          style={{ marginBottom: "0" }}
                        >
                           <Form.Item
                            label="Upper Tolerance"
                            name="quantity_upper_tolerance"
                            initialValue={settings.order_tolerance.upper_tolerance}
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                              // {
                              //   pattern: new RegExp(/^\d+(\.\d+)?$/),
                              //   message: "Only decimal characters are allowed",
                              // },
                              {
                                pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
                                message: "Positive value upto 3 decimal point is accepted",
                              },
                              {
                                validator:(_,value)=>{
                                  if(value>=1)
                                  {
                                    return Promise.resolve();
                                  }
                                  else{
                                    return Promise.reject("Upper Tolerance must be atleast 1%")
                                  }
                                }
                              }
                              
                            ]}
                            className="dBlock"
                          >
                            <Input
                              // className={
                              //   coreOdValidationError ? "showErrorBorder" : ""
                              // }
                              // onChange={findPlannedReels}
                              
                            />
                          </Form.Item>
                          <span className="nonEditable" style={{top:'34px'}}>%</span>

                        </div>
                      </Col>
                      <Col span={12} style={{paddingLeft : '5px'}}>
                        <div className="boxFormType">
                           <Form.Item
                            initialValue={settings.order_tolerance.lower_tolerance }
                            label="Lower Tolerance"
                            name="quantity_lower_tolerance"
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                              // {
                              //   pattern: new RegExp(/^\d+(\.\d+)?$/),
                              //   message: "Only decimal characters are allowed",
                              // },
                              {
                                pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
                                message: "Positive value upto 3 decimal point is accepted",
                              },
                            ]}
                            className="dBlock"
                          >
                          <Input
                              // onChange={findPlannedReels}
                            
                              // className={
                              //   coreOdValidationError ? "showErrorBorder" : ""
                              // }
                            />
                          </Form.Item>
                          <span className="nonEditable" style={{top:'34px'}}>%</span>

                        </div>
                      </Col>
                    
                    </Row>
                </div>

                <div className="drawerField removeStar">
                  <div className="titleWithText">
                    <h5>GSM Tolerance</h5>
                    <p>The GSM of the processed order should be between this tolerance range</p>
                  </div>
                    <Row className="centerAlign " style={{justifyContent : 'space-between'}}>
                      <Col span={12} style={{paddingRight : '5px'}}>
                        <div
                          className="boxFormType"
                          style={{ marginBottom: "0" }}
                        >
                           <Form.Item
                            label="Upper Tolerance"
                            name="gsm_upper_tolerance"
                            initialValue={settings.gsm_tolerance.upper_tolerance }
                            rules={[
                              // {
                              //   pattern: new RegExp(/^\d+(\.\d+)?$/),
                              //   message: "Only decimal characters are allowed",
                              // },
                              {
                                pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
                                message: "Positive value upto 3 decimal point is accepted",
                              },
                            ]}
                            className="dBlock"
                          >
                            <Input
                              // className={
                              //   coreOdValidationError ? "showErrorBorder" : ""
                              // }
                              // onChange={findPlannedReels}
                              
                            />
                          </Form.Item>
                          <span className="nonEditable" style={{top:'34px'}}>%</span>
                        </div>
                      </Col>
                      <Col span={12} style={{paddingLeft : '5px'}}>
                        <div className="boxFormType">
                           <Form.Item
                            initialValue={settings.gsm_tolerance.lower_tolerance }
                            label="Lower Tolerance"
                            name="gsm_lower_tolerance"
                            rules={[
                              // {
                              //   pattern: new RegExp(/^\d+(\.\d+)?$/),
                              //   message: "Only decimal characters are allowed",
                              // },
                              {
                                pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
                                message: "Positive value upto 3 decimal point is accepted",
                              },
                            ]}
                            className="dBlock"
                          >
                          <Input
                              // onChange={findPlannedReels}
                            
                              // className={
                              //   coreOdValidationError ? "showErrorBorder" : ""
                              // }
                            />
                          </Form.Item>
                          <span className="nonEditable" style={{top:'34px'}}>%</span>

                        </div>
                      </Col>
                    
                    </Row>
                </div>
                <div className="drawerField removeStar">
                  <div className="titleWithText">
                    <h5>BF Tolerance</h5>
                    <p>The BF of the processed order should be between this tolerance range</p>
                  </div>
                    <Row className="centerAlign " style={{justifyContent : 'space-between'}}>
                      <Col span={12} style={{paddingRight : '5px'}}>
                        <div
                          className="boxFormType"
                          style={{ marginBottom: "0" }}
                        >
                           <Form.Item
                            label="Upper Tolerance"
                            name="bf_upper_tolerance"
                            initialValue={settings.bf_tolerance.upper_tolerance }
                            rules={[
                              // {
                              //   pattern: new RegExp(/^\d+(\.\d+)?$/),
                              //   message: "Only decimal characters are allowed",
                              // },
                              {
                                pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
                                message: "Positive value upto 3 decimal point is accepted",
                              },
                            ]}
                            className="dBlock"
                          >
                            <Input
                              // className={
                              //   coreOdValidationError ? "showErrorBorder" : ""
                              // }
                              // onChange={findPlannedReels}
                              
                            />
                          </Form.Item>
                          <span className="nonEditable" style={{top:'34px'}}>%</span>

                        </div>
                      </Col>
                      <Col span={12} style={{paddingLeft : '5px'}}>
                        <div className="boxFormType">
                           <Form.Item
                            initialValue={settings.bf_tolerance.lower_tolerance }
                            label="Lower Tolerance"
                            name="bf_lower_tolerance"
                            rules={[
                              //  {
                              //   pattern: new RegExp(/^\d+(\.\d+)?$/),
                              //   message: "Only decimal characters are allowed",
                              // },
                              {
                                pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
                                message: "Positive value upto 3 decimal point is accepted",
                              },
                            ]}
                            className="dBlock"
                          >
                          <Input
                              // onChange={findPlannedReels}
                            
                              // className={
                              //   coreOdValidationError ? "showErrorBorder" : ""
                              // }
                            />
                          </Form.Item>
                          <span className="nonEditable" style={{top:'34px'}}>%</span>

                        </div>
                      </Col>
                    
                    </Row>
                </div>
                <div className="drawerField removeStar">
                  <div className="titleWithText">
                    <h5>Moisture Tolerance</h5>
                    <p>The moisture of the processed order should be between this tolerance range</p>
                  </div>
                    <Row className="centerAlign " style={{justifyContent : 'space-between'}}>
                      <Col span={12} style={{paddingRight : '5px'}}>
                        <div
                          className="boxFormType"
                          style={{ marginBottom: "0" }}
                        >
                           <Form.Item
                            label="Upper Tolerance"
                            name="moisture_upper_tolerance"
                            initialValue={settings.moisture_tolerance.upper_tolerance }
                            rules={[
                              // {
                              //   pattern: new RegExp(/^\d+(\.\d+)?$/),
                              //   message: "Only decimal characters are allowed",
                              // },
                              {
                                pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
                                message: "Positive value upto 3 decimal point is accepted",
                              },
                            ]}
                            className="dBlock"
                          >
                            <Input
                              // className={
                              //   coreOdValidationError ? "showErrorBorder" : ""
                              // }
                              // onChange={findPlannedReels}
                              
                            />
                          </Form.Item>
                          <span className="nonEditable" style={{top:'34px'}}>%</span>

                        </div>
                      </Col>
                      <Col span={12} style={{paddingLeft : '5px'}}>
                        <div className="boxFormType">
                           <Form.Item
                            initialValue={settings.moisture_tolerance.lower_tolerance }
                            label="Lower Tolerance"
                            name="moisture_lower_tolerance"
                            rules={[
                              // {
                              //   pattern: new RegExp(/^\d+(\.\d+)?$/),
                              //   message: "Only decimal characters are allowed",
                              // },
                              {
                                pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
                                message: "Positive value upto 3 decimal point is accepted",
                              },
                            ]}
                            className="dBlock"
                          >
                          <Input
                              // onChange={findPlannedReels}
                            
                              // className={
                              //   coreOdValidationError ? "showErrorBorder" : ""
                              // }
                            />
                          </Form.Item>
                          <span className="nonEditable" style={{top:'34px'}}>%</span>

                        </div>
                      </Col>
                    
                    </Row>
                </div>
                <div className="drawerField removeStar">
                  <div className="titleWithText">
                    <h5>Size Tolerance</h5>
                    <p>The size of the processed order should be between this tolerance range</p>
                  </div>
                    <Row className="centerAlign " style={{justifyContent : 'space-between'}}>
                      <Col span={8} style={{paddingRight : '5px'}}>
                        <div
                          className="boxFormType"
                          style={{ marginBottom: "0" }}
                        >
                           <Form.Item
                            label="Upper Tolerance"
                            name="size_upper_tolerance"
                            initialValue={settings.size_tolerance.upper_tolerance }
                            rules={[
                              // {
                              //   pattern: new RegExp(/^\d+(\.\d+)?$/),
                              //   message: "Only decimal characters are allowed",
                              // },
                              {
                                pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
                                message: "Positive value upto 3 decimal point is accepted",
                              },
                            ]}
                            className="dBlock"
                          >
                            <Input
                              // className={
                              //   coreOdValidationError ? "showErrorBorder" : ""
                              // }
                              // onChange={findPlannedReels}
                              
                            />
                          </Form.Item>
                         
                        </div>
                      </Col>
                      <Col span={8} style={{paddingLeft : '5px'}}>
                        <div className="boxFormType">
                           <Form.Item
                            initialValue={settings.size_tolerance.lower_tolerance }
                            label="Lower Tolerance"
                            name="size_lower_tolerance"
                            rules={[
                             
                              // {
                              //   pattern: new RegExp(/^\d+(\.\d+)?$/),
                              //   message: "Only decimal characters are allowed",
                              // },
                              {
                                pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
                                message: "Positive value upto 3 decimal point is accepted",
                              },
                            ]}
                            className="dBlock"
                          >
                          <Input
                              // onChange={findPlannedReels}
                            
                              // className={
                              //   coreOdValidationError ? "showErrorBorder" : ""
                              // }
                            />
                          </Form.Item>
                         
                        </div>
                      </Col>
                      <Col span={8} style={{paddingLeft : '10px'}}>
                        <div className="boxFormType">
                           <Form.Item
                            label="Unit"
                            name="size_unit"
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              }
                            
                            ]}
                            initialValue={settings.size_tolerance.units }

                            className="dBlock"
                          >
                          <Select
                            placeholder="Unit"
                            suffixIcon={<DownArrowDraw />}
                           // onChange={onChangeWidthUnit}
                          >
                            {unitData.units_management.length.data.map((unit) => (
                              <Option key={unit} value={unit}>
                                {lengthUnit[unit].displayName}
                              </Option>
                            ))}
                          </Select>
                          </Form.Item>
                         
                        </div>
                      </Col>
                    
                    </Row>
                </div>
                <div className="buttonFlex fixedBtm">
                  <Form.Item>
                      <Button htmlType="submit" className="themeBtn">
                        <Iconmoon icon="addcircle" size={16} color="#ffffff" />{" "}
                        Save
                      </Button>
                    
                  </Form.Item>
                </div>
            </Form>
          </HaberForm>
          </DetailFields>
        </RightDrawerContainer>
      </RightDrawerSidebar>
    ) : null;
};

export default OrderToleranceDrawer;